module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <cn-round-form modal=true title-text=round.performance.review.edit.title button-text=cenceo.edit data=data questionnaires=data.questionnaires on-submit=submit on-change=change on-reset=reset is-performance-review=true></cn-round-form> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-round/performance-review-round.edit.modal.html
 ** module id = 267
 ** module chunks = 0
 **/